import { render } from "./MafiaApp.vue?vue&type=template&id=acd81230&scoped=true"
import script from "./MafiaApp.vue?vue&type=script&lang=js"
export * from "./MafiaApp.vue?vue&type=script&lang=js"

import "./MafiaApp.vue?vue&type=style&index=0&id=acd81230&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acd81230"]])

export default __exports__